import { Component, createRef } from 'react';
import Head from 'next/head'
import Page from '../layouts/main'
import Footer from '../components/Footer/footer.module'
import styles from '../styles/modules/privacy-policy.module.scss'
import { PrivacyPolicy as data } from '../util/data'

export default class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analytics: {}
    }
    this.page = createRef();
  }

  componentDidMount() {
    if (this.page.current) {
      this.setState({ ...this.state, analytics: this.page.current.analytics })
    }
  }

  renderItem = (item = {}, index = 0) => {
    switch(item.type) {
      case 'heading':
        return <h4 className={styles['privacy-section-heading']} key={ index }> { item.content } </h4>
      case 'paragraph':
        return <p className={`text-body-medium ${styles['privacy-section-paragraph']}`} key={ index } dangerouslySetInnerHTML={{ __html: item.content}}></p>
    }
  }

  render() {
    const { analytics } = this.state
    return (
      <Page id={styles['page-privacy-policy']} ref={this.page}>
        <Head>
          <title>Privacy Policy - Kudos Golf</title>
        </Head>

        <section className={`section-content ${styles['section-privacy']}`}>
          <h2 className={styles.header}>Privacy Policy</h2>
          <div className={styles['privacy-container']}>
            { data.map((item, index) => this.renderItem(item, index) )}
          </div>
        </section>

        <Footer />
      </Page>
    )
  }
}